import { render, staticRenderFns } from "./borrower-import.component.vue?vue&type=template&id=363e5e65&scoped=true"
import script from "./borrower-import.component.vue?vue&type=script&lang=ts"
export * from "./borrower-import.component.vue?vue&type=script&lang=ts"
import style0 from "./borrower-import.component.vue?vue&type=style&index=0&id=363e5e65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363e5e65",
  null
  
)

export default component.exports